import { Component, afterNextRender, inject, ChangeDetectionStrategy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { NavigationComponent } from './navigation/navigation.component';
import { CookieBannerComponent } from "./cookie-banner/cookie-banner.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CookieBannerComponent, FooterComponent, NavigationComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly doc = inject(DOCUMENT);

  constructor() {
    afterNextRender(() => {
      const splash = this.doc.getElementById('sp-splash') as HTMLElement | null;
      if (!splash) return;

      splash.classList.add('sp-hidden');

      // Remove from DOM after the CSS transition completes (500 ms)
      splash.addEventListener('transitionend', () => splash.remove(), { once: true });
    });
  }
}
